import React, { ReactNode } from 'react';
import { PERMISSIONS, SCOPES } from '@/authorization/authorization.constants';
import { getUserPortalRole } from '@/core/web-storage/webStorage.utils';
import { isAtrfSandbox } from '@/authorization/utils/authorization.utils';

interface AuthorizationGateProps {
  children: ReactNode;
  scopes: SCOPES[];
}

export const hasPermission = (scopes: SCOPES[]) => {
  const userPortalRole = getUserPortalRole();

  let userPermissions = (PERMISSIONS[userPortalRole] ?? []) as SCOPES[];
  if (isAtrfSandbox()) {
    userPermissions = PERMISSIONS.ATRF_SANDBOX;
  }

  return scopes.every((scope) => userPermissions.includes(scope));
};

export default function AuthorizationGate({ children, scopes = [] }: AuthorizationGateProps) {
  const permissionGranted = hasPermission(scopes);

  return permissionGranted ? <>{children}</> : <></>;
}
